import { Clinic } from '../../shared/state/clinic/clinic.store';


export function filterClinicsByTags(clinics: Clinic[], activeTags: string[]): Clinic[] {
    if (activeTags.length === 0) {
        return [...clinics];
    }
    return clinics.filter((clinic) => {
        return clinic.tags?.some((tag) => {
            return activeTags.includes(tag);
        })
    })
}

export function getUniqueTags(clinics: Clinic[]): string[] {
    return [... new Set (clinics.flatMap((clinic) => {
        return clinic.tags??[];
    }))]
}

export function filterClinicsByCities(cities: Clinic[], activeCity: string | null): Clinic[] {
    if (!activeCity) {
        return [...cities];
    }

    return cities.filter((city) => {
        return city.city === activeCity;
    })
}

export function getUniqueCities(cities: Clinic[]): string[] {
    return [... new Set (cities.filter( city => !!city.city).map(
        (c) => {
            return c.city;
        })
    )]
}


